/**
 * Converts radians to degrees.
 * @param rad Radians.
 * @returns Radians.
 */
export function radToDeg(rad: number): number {
  return (rad * 180) / Math.PI;
}
